module.exports = __webpack_public_path__ + "static/bruno_gama-4a6cd23cc6390e37040b132b826d33af.jpg";